import { Store } from "@ngrx/store";
import { Observable, combineLatest, filter, map, of, tap } from "rxjs";

export class StateBuilder<S, T> {
    constructor(
        private store: Store<S>,
        private observable: Observable<T>,
    ) {}

    public get state$(): Observable<T> {
        return this.observable; //.distinctUntilChanged()
    }

    public apply<K extends keyof T>(
        key: K,
        accessor: (state: S) => T[K],
    ): this {
        const select$ = this.store
            .select<T[K]>((s: S) => {
                try {
                    return accessor(s);
                } catch (e) {
                    return undefined;
                }
            })
            .pipe(filter((v) => v !== undefined));
        this.observable = combineLatest([this.observable, select$]).pipe(
            tap(([state, value]) => {
                state[key] = value;
            }),
            map(([state, value]) => state),
        );

        return this;
    }

    public observe<K extends keyof T>(
        key: K,
        otherObservable$: Observable<T[K]>,
    ): this {
        const other$ = otherObservable$.pipe(filter((v) => v != undefined));
        this.observable = combineLatest([this.observable, other$]).pipe(
            tap(([state, value]) => (state[key] = value)),
            map(([state, value]) => state),
        );
        return this;
    }
}

export function stateBuilder<S, T>(
    store: Store<S>,
    state: T,
): StateBuilder<S, T> {
    return new StateBuilder(store, of(state));
}
